export const statusCourier = status => {
    switch ( String(status) ) {
        case 'BOOKING':
            return { status: `รออัพเดท` , color: `primary`}
        case 'SHIPPING':
            return { status: `ระหว่างจัดส่ง` , color: `warning`} 
        case 'RETURN':
            return { status: `รายการตีกลับ` , color: `danger`} 
        case 'COMPLETE':
            return { status: `สำเร็จ` , color: `success`} 
        case 'CANCEL_FAIL':
            return { status: `ยกเลิกไม่สำเร็จ` , color: `dark`}
        case 'CANCEL':
            return { status: `ยกเลิกสำเร็จ` , color: `danger`} 
        case 'PENDING_CANCEL':
            return { status: `รายการขอยกเลิก` , color: `warning`} 
        case 'PENDING_TRANSFER':
            return { status: `รอดำเนินการ` , color: `warning`}
        case 'TRANSFERRED':
            return { status: `โอนคืนแล้ว` , color: `success`}
        case 'CANCEL_TRANSFER':
            return { status: `เกิดข้อผิดพลาด` , color: `dark`}
        default:
            return { status: `ไม่พบสถานะ` , color: `dark`}
    }
};